// extracted by mini-css-extract-plugin
module.exports = {"news-banner-box":"c3","newsBannerBox":"c3","banner-wrap":"c4","bannerWrap":"c4","banner-title":"c5","bannerTitle":"c5","banner-img-box":"c6","bannerImgBox":"c6"};